<template>
  <div class="rates is-pulled-left">
    <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteRate(rate.id)"/>
    <b-field>
        <b-input placeholder="Заголовок" required v-model="rate.title" @change="updateRate(rate)"></b-input>
    </b-field>
    <b-field>
      <b-input placeholder="Описание" type="textarea" required v-model="rate.description" @change="updateRate(rate)"></b-input>
    </b-field>
    <b-field>
      <el-select v-model="symbol" placeholder="Выбрать символ для отображения" @change="symbolChanged">
        <el-option
          v-for="symbol in alp"
          :key="symbol"
          :label="symbol"
          :value="symbol">
        </el-option>
      </el-select>
    </b-field>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'Rate',
    data () {
      return {
        alp: [...'абвгдежзиклмнопрстуфхцчшщэюя'],
        symbol: ''
      }
    },
    props: {
      rate: {
        type: Object,
        required: true
      }
    },
    methods: {
      ...mapActions(['deleteRate', 'updateRate']),
      symbolChanged () {
        this.rate.symbol = this.symbol
        this.updateRate(this.rate)
      }
    },
    created () {
      this.symbol = this.rate.symbol
    }
  }
</script>

<style scoped>
.rates {
  width: 50%;
  position: relative;
  margin: 20px 0px;
}
.delete-icon {
  top: 12px;
  right: 12px;
}
.el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// Rate.vue?4809e77e